<!--
@Author: MIYONGLE
@Desc: 移动端头部
@Date: 2021-04-16 18时
-->
<template>
  <div class='title-solt' v-show="defaultSwitch.isVisibleNav">

    <!-- 导航背景 -->
    <div class="official-nav-mobile-main" :style="{opacity: opacityNum}"></div>

    <!-- 内容 -->
    <div class="title-solt-nav">
      <img v-if="getAddress === 'hui15'" src="../../static/mobile/pic_logo_menu.png" alt="慧用工" />
      <img v-if="getAddress === 'hui5'" src="../../static/mobile/pic_logo_menu5.png" alt="汇用工Logo" />
      <img v-if="getAddress === 'hui6'" src="../../static/mobile/pic_logo_menu6.png" alt="会用工Logo" />
      <img v-if="getAddress === 'hui12'" src="../../static/mobile/pic_logo_menu12.png" alt="惠用工Logo" />

      <!-- 插槽 -->
      <slot></slot>

      <!-- <div class="title-solt-right" v-if="showRigth"> -->
      <div class="title-solt-right">
        <span class="title-solt-icon" @click='defaultSwitch.visibleSwitch = !defaultSwitch.visibleSwitch'></span>
      </div>
      
    </div>

    <!-- 弹窗 -->
    <van-popup v-model="defaultSwitch.visibleSwitch" :overlay='true' 
      position="right" 
      class='slide-aside'>

      <div class="slide-aside-con">
        <span class="slide-aside-con-item" @click="jumpPage('/mIndex')">首页</span>
        <van-collapse v-model="activeNames" accordion>
          <van-collapse-item v-for="(item,index) in navBussinessConts" 
            :key="index" :title="item.title">
            <span v-for="(itemSon,indexSon) in item.children" :key="indexSon" @click="jumpPage(itemSon.path)">
              {{itemSon.title}}
            </span>
          </van-collapse-item>
        </van-collapse>
        <span class="slide-aside-con-item" @click="jumpPage('/mKnowUs')">关于我们</span>
      </div>
      
    </van-popup>
  </div>
</template>

<script type="text/javascript">
  import {NAV_BUSSINESS_CONTS} from '.././service/businessConsts';
  import {changeJumpPageUrl} from '../filters/filters';
  
  export default {
    name: "mMenusNav",
    data() {
      return {
        getAddress: '',
        navBussinessConts: [],
        activeNames: ['1'],
        opacityNum: 0,
        opacityNumTemp: 0,

        defaultSwitch: {
          visibleSwitch: false,
          isVisibleNav: true,
        }, // 页面默认开关

        // showRigth:true,
      }
    },

    mounted () {
      window.addEventListener('scroll', this.handleScroll, true);
      this.getAddress = this.getSiteAddress().whichHui; 
    },

    created() {
      let pathTemp = window.location.hash;
      let path = pathTemp.substring(1, pathTemp.length);
      // 如果是指定推广页的话，不展示页面跳转
      // if (path === '/mExtensionPage') {
      //   this.showRigth = false
      // }


      // 进行一次深拷贝
      let tempArr = JSON.parse(JSON.stringify(NAV_BUSSINESS_CONTS)).slice(1);
      this.navBussinessConts = tempArr.splice(0,tempArr.length-1);
    },

    methods: {

      // 页面跳转
      jumpPage(url){
        this.$router.push({
          path: changeJumpPageUrl(url)
        })
        this.defaultSwitch.visibleSwitch = false;
      },

      //页面滑动
      handleScroll() {

        let scrollTop = 0;
        scrollTop = window.pageYOffset || document.body.scrollTop || document.scrollingElement.scrollTop;

        // 判断透明度
        if(scrollTop > 0){
          let opacity = scrollTop/500;
          this.opacityNum = opacity > 1 ? 1 : opacity;
        }else{
          this.opacityNum = 0;
        }

        this.defaultSwitch.isVisibleNav = scrollTop > document.body.scrollHeight/1.5 ? false : true;
      },
    }
  }
</script>

<style>
  .slide-aside-con .van-cell{
    height: 120px;
    line-height: 120px;
    padding: 0;
    font-size: 30px;
    font-weight: 600;
    text-align: left;
    background-color:transparent;
  }

  .slide-aside-con .van-cell__right-icon{
    font-size: 40px;
    margin-top: 46px;
    color: rgba(92, 92, 93, 1)
  }

  .slide-aside-con [class*=van-hairline]::after{
    border: 0;
  }

  .slide-aside-con [class*=van-hairline]::after{
    border: 0;
  }

  .slide-aside-con .van-collapse-item__content{
    padding: 0;
  }

  .slide-aside-con .van-collapse-item__content span{
    display: block;
    text-align: left;
    color: #100F0F;
    font-size: 30px;
    height: 120px;
    font-weight: 600;
    line-height: 120px;
  }

  .slide-aside-con .van-cell:not(:last-child)::after{
    border-bottom: 0;
  }

  .slide-aside-con .van-cell:not(:last-child)::after{
    border-bottom: 0;
  }



</style>

<style lang="scss" scoped>

  // 头部
  .title-solt{
    width: 100%;
    height: 98px;
    line-height: 98px;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 88;
    .official-nav-mobile-main{
      background: #100F0F;
      height: 98px;
      width: 100%;
    }
  }

  // 内容
  .title-solt-nav{
    display: flex;
    position: fixed;
    top: 0;
    width: 100%;
    padding: 0 22px;
    justify-content: space-between;
    img{
      width: 168px;
      height: 78px;
      margin-top: 10px;
    }

    span{
      font-weight: 600;
      color: #FFFFFF;
      font-size: 32px;
    }

    .title-solt-right{
      width: 138px;
      text-align: right;
      .title-solt-icon{
        width: 44px;
        height: 44px;
        display: block;
        background:url('../../static/mobile/ic_mune.png') no-repeat center;
        background-size:100%;
        margin-top: 28px;
        text-align: right;
        float: right;
      }
    }
  }

  //弹窗
  .slide-aside{
    background:#FFFFFF;
    height:100%;
    width:520px;
    padding-left: 50px;
    padding-right: 38px;
    box-sizing: border-box;
    .slide-aside-con{
      margin-top:60px;
      .slide-aside-con-item{
        display: block;
        text-align: left;
        font-size: 30px;
        height: 120px;
        display: block;
        font-weight: 600;
        color: #100F0F;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/mMenusNav.vue